import React from 'react';
import { ThemeProvider } from '@mui/material';
import { useAutoTranslation, useLanguage } from 'src/hooks/useTranslate';
import { muiLocaleComponents, withMuiLocale } from './muiLocale';

/**
 * The app's MUI ThemeProvider, with MUI's own text (grid footers and menus,
 * pagination, autocomplete, pickers) in the selected language (TGCLOUD-1893).
 *
 * It re-renders as each translation arrives, but the theme it provides is
 * rebuilt only when one of MUI's own texts changes (`signature`), so a batch
 * of translations for some other screen does not restyle the whole app. Its
 * children are the element Dashboard passed, which React does not re-render
 * while the theme stays the same.
 */
export default function LocalisedMuiTheme({ theme, children }) {
  const t = useAutoTranslation();
  const lang = useLanguage();
  const built = muiLocaleComponents(t, lang);
  const signature = built ? built.signature : '';

  const localised = React.useMemo(
    () => withMuiLocale(theme, built?.components),
    [theme, signature] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return <ThemeProvider theme={localised}>{children}</ThemeProvider>;
}
